// import { useCallback, useEffect, useState } from "react";
// import { Api } from "../../../../services/Api";
// import { Utils } from "../../../../utils";
// import Skeleton from "react-loading-skeleton";
// import * as Icons from "react-feather";
// import { Link, useParams } from "react-router-dom";

// const FacturationGreffe = () => {
//     const { id } = useParams();
//     const [activeTab, setActiveTab] = useState("parametres");
//     const [loading, setLoading] = useState(true);
//     const [parametres, setParametres] = useState([]);
//     const [juridictions, setJuridictions] = useState([]);
//     const [services, setServices] = useState([]);
//     const [selectedJuridiction, setSelectedJuridiction] = useState("");
//     const [selectedService, setSelectedService] = useState("");
//     const [montantBase, setMontantBase] = useState("");
//     const [tauxTVA, setTauxTVA] = useState("18");
//     const [delaiTraitement, setDelaiTraitement] = useState("");
//     const [historique, setHistorique] = useState([]);

//     // Fonction pour récupérer les données des paramètres de facturation
//     const fetchParametresFacturation = useCallback(async () => {
//         setLoading(true);
//         try {
//             // Appel API pour récupérer les paramètres de facturation de l'organisation
//             const response = await Api.get(`recouv/billing-config/company/${id}/`);
//             if (response) {
//                 setParametres(response.results || []);
//             }

//             // Récupérer les juridictions
//             const juridictionsResponse = await Api.get('recouv/jurisdiction/');
//             if (juridictionsResponse) {
//                 setJuridictions(juridictionsResponse.results || []);
//             }

//             // Récupérer les services
//             const servicesResponse = await Api.get('recouv/service/');
//             if (servicesResponse) {
//                 setServices(servicesResponse.results || []);
//             }

//             // Récupérer l'historique des modifications
//             const historiqueResponse = await Api.get(`recouv/billing-config/history/${id}/`);
//             if (historiqueResponse) {
//                 setHistorique(historiqueResponse.results || []);
//             }
//         } catch (error) {
//             console.error("Erreur lors de la récupération des paramètres de facturation:", error);
//         } finally {
//             setLoading(false);
//         }
//     }, [id]);

//     useEffect(() => {
//         fetchParametresFacturation();
//     }, [fetchParametresFacturation]);

//     // Gérer l'ajout d'un nouveau paramètre de facturation
//     const handleAjouterParametre = async () => {
//         if (!selectedJuridiction || !selectedService || !montantBase || !tauxTVA || !delaiTraitement) {
//             alert("Veuillez remplir tous les champs obligatoires.");
//             return;
//         }

//         setLoading(true);
//         try {
//             const payload = {
//                 company_id: id,
//                 jurisdiction_id: selectedJuridiction,
//                 service_id: selectedService,
//                 base_amount: parseFloat(montantBase),
//                 vat_rate: parseFloat(tauxTVA),
//                 processing_delay: parseInt(delaiTraitement)
//             };

//             const response = await Api.post('recouv/billing-config/', payload);
//             if (response) {
//                 // Réinitialiser les champs
//                 setSelectedJuridiction("");
//                 setSelectedService("");
//                 setMontantBase("");
//                 setDelaiTraitement("");
//                 // Rafraîchir la liste
//                 fetchParametresFacturation();
//                 alert("Paramètre de facturation ajouté avec succès.");
//             }
//         } catch (error) {
//             console.error("Erreur lors de l'ajout du paramètre de facturation:", error);
//             alert("Une erreur est survenue lors de l'ajout du paramètre.");
//         } finally {
//             setLoading(false);
//         }
//     };

//     // Gérer la mise à jour d'un paramètre de facturation
//     const handleUpdateParametre = async (parametreId) => {
//         if (!selectedJuridiction || !selectedService || !montantBase || !tauxTVA || !delaiTraitement) {
//             alert("Veuillez remplir tous les champs obligatoires.");
//             return;
//         }

//         setLoading(true);
//         try {
//             const payload = {
//                 jurisdiction_id: selectedJuridiction,
//                 service_id: selectedService,
//                 base_amount: parseFloat(montantBase),
//                 vat_rate: parseFloat(tauxTVA),
//                 processing_delay: parseInt(delaiTraitement)
//             };

//             const response = await Api.put(`recouv/billing-config/${parametreId}/`, payload);
//             if (response) {
//                 // Réinitialiser les champs
//                 setSelectedJuridiction("");
//                 setSelectedService("");
//                 setMontantBase("");
//                 setDelaiTraitement("");
//                 // Rafraîchir la liste
//                 fetchParametresFacturation();
//                 // Changer l'onglet actif pour afficher la liste
//                 setActiveTab("liste");
//                 alert("Paramètre de facturation mis à jour avec succès.");
//             }
//         } catch (error) {
//             console.error("Erreur lors de la mise à jour du paramètre de facturation:", error);
//             alert("Une erreur est survenue lors de la mise à jour du paramètre.");
//         } finally {
//             setLoading(false);
//         }
//     };

//     // Gérer la suppression d'un paramètre de facturation
//     const handleDeleteParametre = async (parametreId) => {
//         if (window.confirm("Êtes-vous sûr de vouloir supprimer ce paramètre de facturation ?")) {
//             setLoading(true);
//             try {
//                 await Api.delete(`recouv/billing-config/${parametreId}/`);
//                 fetchParametresFacturation();
//                 alert("Paramètre de facturation supprimé avec succès.");
//             } catch (error) {
//                 console.error("Erreur lors de la suppression du paramètre de facturation:", error);
//                 alert("Une erreur est survenue lors de la suppression du paramètre.");
//             } finally {
//                 setLoading(false);
//             }
//         }
//     };

//     // Gérer l'édition d'un paramètre existant
//     const handleEditParametre = (parametre) => {
//         setSelectedJuridiction(parametre.jurisdiction_id);
//         setSelectedService(parametre.service_id);
//         setMontantBase(parametre.base_amount.toString());
//         setTauxTVA(parametre.vat_rate.toString());
//         setDelaiTraitement(parametre.processing_delay.toString());
//         setActiveTab("parametres");
//     };

//     // Trouver le nom de la juridiction et du service
//     const getJuridictionName = (id) => {
//         const juridiction = juridictions.find(j => j.id === id);
//         return juridiction ? juridiction.name : "N/A";
//     };

//     const getServiceName = (id) => {
//         const service = services.find(s => s.id === id);
//         return service ? service.name : "N/A";
//     };

//     // Rendre l'onglet Paramètres
//     const renderParametresTab = () => {
//         return (
//             <div className="p-6">
//                 <div className="mb-6">
//                     <h2 className="text-2xl font-bold mb-2">Configuration des tarifs</h2>
//                     <p className="text-gray-600">Définissez les paramètres de facturation selon la juridiction et le service.</p>
//                 </div>

//                 <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
//                     <div>
//                         <label className="block mb-2 font-medium">Juridiction</label>
//                         <select
//                             className="w-full p-3 border rounded-md"
//                             value={selectedJuridiction}
//                             onChange={(e) => setSelectedJuridiction(e.target.value)}
//                         >
//                             <option value="">Sélectionner une juridiction</option>
//                             {juridictions.map(juridiction => (
//                                 <option key={juridiction.id} value={juridiction.id}>
//                                     {juridiction.name}
//                                 </option>
//                             ))}
//                         </select>
//                         <p className="text-sm text-gray-500 mt-1">La juridiction où le service sera appliqué</p>
//                     </div>

//                     <div>
//                         <label className="block mb-2 font-medium">Service</label>
//                         <select
//                             className="w-full p-3 border rounded-md"
//                             value={selectedService}
//                             onChange={(e) => setSelectedService(e.target.value)}
//                         >
//                             <option value="">Sélectionner un service</option>
//                             {services.map(service => (
//                                 <option key={service.id} value={service.id}>
//                                     {service.name}
//                                 </option>
//                             ))}
//                         </select>
//                         <p className="text-sm text-gray-500 mt-1">Le service pour lequel configurer la facturation</p>
//                     </div>
//                 </div>

//                 <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
//                     <div>
//                         <label className="block mb-2 font-medium">Montant de base (FCFA)</label>
//                         <input
//                             type="number"
//                             className="w-full p-3 border rounded-md"
//                             placeholder="ex: 50000"
//                             value={montantBase}
//                             onChange={(e) => setMontantBase(e.target.value)}
//                         />
//                         <p className="text-sm text-gray-500 mt-1">Montant de base pour ce service et cette juridiction</p>
//                     </div>

//                     <div>
//                         <label className="block mb-2 font-medium">Taux de TVA (%)</label>
//                         <input
//                             type="number"
//                             className="w-full p-3 border rounded-md"
//                             value={tauxTVA}
//                             onChange={(e) => setTauxTVA(e.target.value)}
//                         />
//                         <p className="text-sm text-gray-500 mt-1">Taux de TVA applicable</p>
//                     </div>
//                 </div>

//                 <div className="mb-6">
//                     <label className="block mb-2 font-medium">Délai de traitement (jours)</label>
//                     <input
//                         type="number"
//                         className="w-full p-3 border rounded-md"
//                         placeholder="ex: 15"
//                         value={delaiTraitement}
//                         onChange={(e) => setDelaiTraitement(e.target.value)}
//                     />
//                     <p className="text-sm text-gray-500 mt-1">Délai estimé pour le traitement de ce service</p>
//                 </div>

//                 <div className="flex justify-end gap-4">
//                     <button
//                         onClick={() => {
//                             setSelectedJuridiction("");
//                             setSelectedService("");
//                             setMontantBase("");
//                             setDelaiTraitement("");
//                             setActiveTab("liste");
//                         }}
//                         className="bg-gray-200 text-gray-800 px-6 py-3 rounded-md hover:bg-gray-300"
//                     >
//                         Annuler
//                     </button>
//                     <button
//                         onClick={handleAjouterParametre}
//                         className="bg-black text-white px-6 py-3 rounded-md hover:bg-gray-800"
//                     >
//                         Enregistrer les paramètres
//                     </button>
//                 </div>
//             </div>
//         );
//     };

//     // Rendre l'onglet Liste
//     const renderListeTab = () => {
//         return (
//             <div className="p-6">
//                 <div className="mb-6">
//                     <h2 className="text-2xl font-bold mb-2">Liste des paramètres de facturation</h2>
//                     <p className="text-gray-600">Consultez et gérez tous les paramètres de facturation configurés</p>
//                 </div>

//                 <div className="overflow-x-auto mb-4">
//                     <table className="min-w-full bg-white">
//                         <thead>
//                             <tr className="border-b">
//                                 <th className="py-3 px-4 text-left">Juridiction</th>
//                                 <th className="py-3 px-4 text-left">Service</th>
//                                 <th className="py-3 px-4 text-left">Montant de base</th>
//                                 <th className="py-3 px-4 text-left">TVA (%)</th>
//                                 <th className="py-3 px-4 text-left">Délai (jours)</th>
//                                 <th className="py-3 px-4 text-left">Actions</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {loading ? (
//                                 <tr>
//                                     <td colSpan="6">
//                                         <Skeleton count={3} />
//                                     </td>
//                                 </tr>
//                             ) : parametres.length === 0 ? (
//                                 <tr>
//                                     <td colSpan="6" className="py-4 px-4 text-center">
//                                         Aucun paramètre de facturation configuré
//                                     </td>
//                                 </tr>
//                             ) : (
//                                 parametres.map((parametre) => (
//                                     <tr key={parametre.id} className="border-b hover:bg-gray-50">
//                                         <td className="py-3 px-4">{getJuridictionName(parametre.jurisdiction_id)}</td>
//                                         <td className="py-3 px-4">{getServiceName(parametre.service_id)}</td>
//                                         <td className="py-3 px-4">{parametre.base_amount.toLocaleString()} FCFA</td>
//                                         <td className="py-3 px-4">{parametre.vat_rate}%</td>
//                                         <td className="py-3 px-4">{parametre.processing_delay} jours</td>
//                                         <td className="py-3 px-4">
//                                             <div className="flex space-x-2">
//                                                 <button
//                                                     onClick={() => handleEditParametre(parametre)}
//                                                     className="text-gray-600 hover:text-blue-600"
//                                                 >
//                                                     <Icons.Edit size={18} />
//                                                 </button>
//                                                 <button
//                                                     onClick={() => handleDeleteParametre(parametre.id)}
//                                                     className="text-gray-600 hover:text-red-600"
//                                                 >
//                                                     <Icons.Trash2 size={18} />
//                                                 </button>
//                                             </div>
//                                         </td>
//                                     </tr>
//                                 ))
//                             )}
//                         </tbody>
//                     </table>
//                 </div>
//             </div>
//         );
//     };

//     // Rendre l'onglet Historique
//     const renderHistoriqueTab = () => {
//         return (
//             <div className="p-6">
//                 <div className="mb-6">
//                     <h2 className="text-2xl font-bold mb-2">Historique des modifications</h2>
//                     <p className="text-gray-600">Historique des changements de paramètres de facturation</p>
//                 </div>

//                 {loading ? (
//                     <Skeleton count={5} />
//                 ) : historique.length === 0 ? (
//                     <p className="text-gray-600 italic">Aucune modification enregistrée pour le moment.</p>
//                 ) : (
//                     <div className="space-y-4">
//                         {historique.map((item, index) => (
//                             <div key={index} className="border p-4 rounded-md">
//                                 <div className="flex justify-between mb-2">
//                                     <span className="font-semibold">{item.action}</span>
//                                     <span className="text-gray-500">{item.timestamp}</span>
//                                 </div>
//                                 <p>
//                                     {item.details}
//                                 </p>
//                             </div>
//                         ))}
//                     </div>
//                 )}
//             </div>
//         );
//     };

//     return (
//         <div className="max-w-6xl mx-auto bg-gray-50 min-h-screen">
//             <h1 className="text-3xl font-bold p-6">Paramètres de Facturation</h1>

//             {/* Onglets */}
//             <div className="flex border-b bg-white">
//                 <button
//                     className={`py-4 px-8 text-center ${activeTab === "parametres" ? "border-b-2 border-black font-semibold" : "text-gray-500"}`}
//                     onClick={() => setActiveTab("parametres")}
//                 >
//                     Paramètres
//                 </button>
//                 <button
//                     className={`py-4 px-8 text-center ${activeTab === "liste" ? "border-b-2 border-black font-semibold" : "text-gray-500"}`}
//                     onClick={() => setActiveTab("liste")}
//                 >
//                     Liste
//                 </button>
//                 <button
//                     className={`py-4 px-8 text-center ${activeTab === "historique" ? "border-b-2 border-black font-semibold" : "text-gray-500"}`}
//                     onClick={() => setActiveTab("historique")}
//                 >
//                     Historique
//                 </button>
//             </div>

//             {/* Contenu en fonction de l'onglet actif */}
//             <div className="bg-white rounded-b-lg shadow-sm">
//                 {activeTab === "parametres" && renderParametresTab()}
//                 {activeTab === "liste" && renderListeTab()}
//                 {activeTab === "historique" && renderHistoriqueTab()}
//             </div>
//         </div>
//     );
// };

// export default FacturationGreffe;



import { useCallback, useEffect, useState } from "react";
import { Api } from "../../../../services/Api";
import { Utils } from "../../../../utils";
import Skeleton from "react-loading-skeleton";
import * as Icons from "react-feather";
import { Link, useParams } from "react-router-dom";

const FacturationGreffe = () => {
    const { id } = useParams();
    const [activeTab, setActiveTab] = useState("parametres");
    const [loading, setLoading] = useState(false);
    const [parametres, setParametres] = useState([
        {
            id: 1,
            jurisdiction_id: 1,
            service_id: 1,
            base_amount: 50000,
            vat_rate: 18,
            processing_delay: 15
        },
        {
            id: 2,
            jurisdiction_id: 2,
            service_id: 2,
            base_amount: 35000,
            vat_rate: 18,
            processing_delay: 10
        }
    ]);
    const [juridictions, setJuridictions] = useState([
        { id: 1, name: "Abidjan" },
        { id: 2, name: "Bouaké" },
        { id: 3, name: "Yamoussoukro" },
        { id: 4, name: "Korhogo" }
    ]);
    const [services, setServices] = useState([
        { id: 1, name: "Creation d'entreprise" },
        { id: 2, name: "Modification des statuts" },
        { id: 3, name: "Annonces Légales" },
        { id: 4, name: "Changement de dirigeant" },
        { id: 5, name: "Dissolution" },
        { id: 6, name: "Radiation" }
    ]);
    const [selectedJuridiction, setSelectedJuridiction] = useState("");
    const [selectedService, setSelectedService] = useState("");
    const [montantBase, setMontantBase] = useState("");
    const [tauxTVA, setTauxTVA] = useState("18");
    const [delaiTraitement, setDelaiTraitement] = useState("");
    const [historique, setHistorique] = useState([]);


    const fetchParametresFacturation = useCallback(async () => {
        setLoading(true);

        setTimeout(() => {
            setHistorique([
                {
                    id: 1,
                    action: "Ajout",
                    timestamp: "05/03/2025 14:23",
                    details: "Ajout d'un paramètre de facturation pour Abidjan - Creation d'entreprise"
                },
                {
                    id: 2,
                    action: "Modification",
                    timestamp: "08/03/2025 09:15",
                    details: "Modification du montant de base de 45000 FCFA à 50000 FCFA pour Abidjan - Creation d'entreprise"
                },
                {
                    id: 3,
                    action: "Ajout",
                    timestamp: "10/03/2025 16:38",
                    details: "Ajout d'un paramètre de facturation pour Bouaké - Modification des statuts"
                }
            ]);

            setLoading(false);
        }, 800);
    }, [id]);

    useEffect(() => {
        fetchParametresFacturation();
    }, [fetchParametresFacturation]);

    const handleAjouterParametre = async () => {
        if (!selectedJuridiction || !selectedService || !montantBase || !tauxTVA || !delaiTraitement) {
            alert("Veuillez remplir tous les champs obligatoires.");
            return;
        }

        setLoading(true);

        setTimeout(() => {
            const newParametre = {
                id: parametres.length + 1,
                jurisdiction_id: parseInt(selectedJuridiction),
                service_id: parseInt(selectedService),
                base_amount: parseFloat(montantBase),
                vat_rate: parseFloat(tauxTVA),
                processing_delay: parseInt(delaiTraitement)
            };

            setParametres([...parametres, newParametre]);

            const newHistorique = {
                id: historique.length + 1,
                action: "Ajout",
                timestamp: new Date().toLocaleDateString() + " " + new Date().toLocaleTimeString().slice(0, 5),
                details: `Ajout d'un paramètre de facturation pour ${getJuridictionName(newParametre.jurisdiction_id)} - ${getServiceName(newParametre.service_id)}`
            };

            setHistorique([newHistorique, ...historique]);

            setSelectedJuridiction("");
            setSelectedService("");
            setMontantBase("");
            setDelaiTraitement("");

            alert("Paramètre de facturation ajouté avec succès.");
            setLoading(false);

            setActiveTab("liste");
        }, 800);
    };

    const handleUpdateParametre = async (parametreId) => {
        if (!selectedJuridiction || !selectedService || !montantBase || !tauxTVA || !delaiTraitement) {
            alert("Veuillez remplir tous les champs obligatoires.");
            return;
        }

        setLoading(true);

        setTimeout(() => {
            const updatedParametres = parametres.map(param => {
                if (param.id === parametreId) {
                    return {
                        ...param,
                        jurisdiction_id: parseInt(selectedJuridiction),
                        service_id: parseInt(selectedService),
                        base_amount: parseFloat(montantBase),
                        vat_rate: parseFloat(tauxTVA),
                        processing_delay: parseInt(delaiTraitement)
                    };
                }
                return param;
            });

            setParametres(updatedParametres);

            const newHistorique = {
                id: historique.length + 1,
                action: "Modification",
                timestamp: new Date().toLocaleDateString() + " " + new Date().toLocaleTimeString().slice(0, 5),
                details: `Modification du paramètre de facturation pour ${getJuridictionName(parseInt(selectedJuridiction))} - ${getServiceName(parseInt(selectedService))}`
            };

            setHistorique([newHistorique, ...historique]);

            setSelectedJuridiction("");
            setSelectedService("");
            setMontantBase("");
            setDelaiTraitement("");

            alert("Paramètre de facturation mis à jour avec succès.");
            setLoading(false);

            setActiveTab("liste");
        }, 800);
    };

    const handleDeleteParametre = async (parametreId) => {
        if (window.confirm("Êtes-vous sûr de vouloir supprimer ce paramètre de facturation ?")) {
            setLoading(true);

            const parametreToDelete = parametres.find(p => p.id === parametreId);

            setTimeout(() => {
                const filteredParametres = parametres.filter(param => param.id !== parametreId);
                setParametres(filteredParametres);

                const newHistorique = {
                    id: historique.length + 1,
                    action: "Suppression",
                    timestamp: new Date().toLocaleDateString() + " " + new Date().toLocaleTimeString().slice(0, 5),
                    details: `Suppression du paramètre de facturation pour ${getJuridictionName(parametreToDelete.jurisdiction_id)} - ${getServiceName(parametreToDelete.service_id)}`
                };

                setHistorique([newHistorique, ...historique]);

                alert("Paramètre de facturation supprimé avec succès.");
                setLoading(false);
            }, 800);
        }
    };

    const handleEditParametre = (parametre) => {
        setSelectedJuridiction(parametre.jurisdiction_id.toString());
        setSelectedService(parametre.service_id.toString());
        setMontantBase(parametre.base_amount.toString());
        setTauxTVA(parametre.vat_rate.toString());
        setDelaiTraitement(parametre.processing_delay.toString());
        setActiveTab("parametres");
    };

    const getJuridictionName = (id) => {
        const juridiction = juridictions.find(j => j.id === id);
        return juridiction ? juridiction.name : "N/A";
    };

    const getServiceName = (id) => {
        const service = services.find(s => s.id === id);
        return service ? service.name : "N/A";
    };

    const renderParametresTab = () => {
        return (
            <div className=" text-black p-6">
                <div className="mb-6">
                    <h2 className="text-2xl font-bold mb-2">Configuration des tarifs</h2>
                    <p className="text-gray-600">Définissez les paramètres de facturation selon la juridiction et le service.</p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                    <div>
                        <label className="block mb-2 font-medium">Juridiction</label>
                        <select
                            className="w-full p-3 border rounded-md focus:ring-2 focus:ring-orange-500"
                            value={selectedJuridiction}
                            onChange={(e) => setSelectedJuridiction(e.target.value)}
                        >
                            <option value="">Sélectionner une juridiction</option>
                            {juridictions.map(juridiction => (
                                <option key={juridiction.id} value={juridiction.id}>
                                    {juridiction.name}
                                </option>
                            ))}
                        </select>
                        <p className="text-sm text-gray-500 mt-1">La juridiction où le service sera appliqué</p>
                    </div>

                    <div>
                        <label className="block mb-2 font-medium">Service</label>
                        <select
                            className="w-full p-3 border rounded-md focus:ring-2 focus:ring-orange-500"
                            value={selectedService}
                            onChange={(e) => setSelectedService(e.target.value)}
                        >
                            <option value="">Sélectionner un service</option>
                            {services.map(service => (
                                <option key={service.id} value={service.id}>
                                    {service.name}
                                </option>
                            ))}
                        </select>
                        <p className="text-sm text-gray-500 mt-1">Le service pour lequel configurer la facturation</p>
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                    <div>
                        <label className="block mb-2 font-medium">Montant de base (FCFA)</label>
                        <input
                            type="number"
                            className="w-full p-3 border rounded-md focus:ring-2 focus:ring-orange-500"
                            placeholder="ex: 50000"
                            value={montantBase}
                            onChange={(e) => setMontantBase(e.target.value)}
                        />
                        <p className="text-sm text-gray-500 mt-1">Montant de base pour ce service et cette juridiction</p>
                    </div>

                    <div>
                        <label className="block mb-2 font-medium">Taux de TVA (%)</label>
                        <input
                            type="number"
                            className="w-full p-3 border rounded-md focus:ring-2 focus:ring-orange-500"
                            value={tauxTVA}
                            onChange={(e) => setTauxTVA(e.target.value)}
                        />
                        <p className="text-sm text-gray-500 mt-1">Taux de TVA applicable</p>
                    </div>
                </div>

                <div className="mb-6">
                    <label className="block mb-2 font-medium">Délai de traitement (jours)</label>
                    <input
                        type="number"
                        className="w-full p-3 border rounded-md focus:ring-2 focus:ring-orange-500"
                        placeholder="ex: 15"
                        value={delaiTraitement}
                        onChange={(e) => setDelaiTraitement(e.target.value)}
                    />
                    <p className="text-sm text-gray-500 mt-1">Délai estimé pour le traitement de ce service</p>
                </div>

                <div className="flex justify-end gap-4">
                    <button
                        onClick={() => {
                            setSelectedJuridiction("");
                            setSelectedService("");
                            setMontantBase("");
                            setDelaiTraitement("");
                            setActiveTab("liste");
                        }}
                        className="bg-gray-200 text-gray-800 px-6 py-3 rounded-md hover:bg-gray-300"
                    >
                        Annuler
                    </button>
                    <button
                        onClick={handleAjouterParametre}
                        className="bg-orange-500 text-white px-6 py-3 rounded-md hover:bg-orange-700"
                    >
                        Enregistrer les paramètres
                    </button>
                </div>
            </div>
        );
    };

    // Rendre l'onglet Liste
    const renderListeTab = () => {
        return (
            <div className=" text-black p-6">
                <div className="mb-6">
                    <h2 className="text-2xl font-bold mb-2">Liste des paramètres de facturation</h2>
                    <p className="text-gray-600">Consultez et gérez tous les paramètres de facturation configurés</p>
                </div>

                <div className="overflow-x-auto mb-4">
                    <table className="min-w-full bg-white border rounded-lg">
                        <thead>
                            <tr className="bg-transparent text-black">
                                <th className="py-3 px-4 text-left border-b">Juridiction</th>
                                <th className="py-3 px-4 text-left border-b">Service</th>
                                <th className="py-3 px-4 text-left border-b">Montant de base</th>
                                <th className="py-3 px-4 text-left border-b">TVA (%)</th>
                                <th className="py-3 px-4 text-left border-b">Délai (jours)</th>
                                <th className="py-3 px-4 text-left border-b">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr>
                                    <td colSpan="6" className="py-4 px-4">
                                        <Skeleton count={3} />
                                    </td>
                                </tr>
                            ) : parametres.length === 0 ? (
                                <tr>
                                    <td colSpan="6" className="py-4 px-4 text-center">
                                        Aucun paramètre de facturation configuré
                                    </td>
                                </tr>
                            ) : (
                                parametres.map((parametre) => (
                                    <tr key={parametre.id} className="border-b hover:bg-gray-50">
                                        <td className="py-3 px-4">{getJuridictionName(parametre.jurisdiction_id)}</td>
                                        <td className="py-3 px-4">{getServiceName(parametre.service_id)}</td>
                                        <td className="py-3 px-4">{parametre.base_amount.toLocaleString()} FCFA</td>
                                        <td className="py-3 px-4">{parametre.vat_rate}%</td>
                                        <td className="py-3 px-4">{parametre.processing_delay} jours</td>
                                        <td className="py-3 px-4">
                                            <div className="flex space-x-2">
                                                <button
                                                    onClick={() => handleEditParametre(parametre)}
                                                    className="bg-gray-500 text-white px-2 py-1 rounded flex items-center"
                                                >
                                                    <Icons.Edit size={18} className="mr-1" />
                                                    Éditer
                                                </button>
                                                <button
                                                    onClick={() => handleDeleteParametre(parametre.id)}
                                                    className="bg-gray-500 text-white px-2 py-1 rounded flex items-center"
                                                >
                                                    <Icons.Trash2 size={18} className="mr-1" />
                                                    Supprimer
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    };

    // Rendre l'onglet Historique
    const renderHistoriqueTab = () => {
        return (
            <div className="text-black p-6">
                <div className="mb-6">
                    <h2 className="text-2xl font-bold mb-2">Historique des modifications</h2>
                    <p className="text-gray-600">Historique des changements de paramètres de facturation</p>
                </div>

                {loading ? (
                    <Skeleton count={5} />
                ) : historique.length === 0 ? (
                    <p className="text-gray-600 italic">Aucune modification enregistrée pour le moment.</p>
                ) : (
                    <div className="space-y-4">
                        {historique.map((item, index) => (
                            <div key={index} className="border p-4 rounded-md">
                                <div className="flex justify-between mb-2">
                                    <span className="font-semibold">{item.action}</span>
                                    <span className="text-gray-500">{item.timestamp}</span>
                                </div>
                                <p>
                                    {item.details}
                                </p>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        );
    };

    return (
        <div className="text-black p-4">

            {/* Onglets */}
            <div className="flex border-b">
                <button
                    className={`py-3 px-6 text-base font-medium rounded-t-lg transition-colors ${activeTab === "parametres"
                        ? 'bg-orange-500 text-white border-b-2 border-orange-500'
                        : 'text-gray-700 hover:bg-gray-100'
                        }`}
                    onClick={() => setActiveTab("parametres")}
                >
                    Paramètres
                </button>
                <button
                    className={`py-3 px-6 text-base font-medium rounded-t-lg transition-colors ${activeTab === "liste"
                        ? 'bg-orange-500 text-white border-b-2 border-orange-500'
                        : 'text-gray-700 hover:bg-gray-100'
                        }`}
                    onClick={() => setActiveTab("liste")}
                >
                    Liste
                </button>
                <button
                    className={`py-3 px-6 text-base font-medium rounded-t-lg transition-colors ${activeTab === "historique"
                        ? 'bg-orange-500 text-white border-b-2 border-orange-500'
                        : 'text-gray-700 hover:bg-gray-100'
                        }`}
                    onClick={() => setActiveTab("historique")}
                >
                    Historique
                </button>
            </div>

            {/* Contenu en fonction de l'onglet actif */}
            <div className="bg-white rounded-b-lg shadow-sm">
                {activeTab === "parametres" && renderParametresTab()}
                {activeTab === "liste" && renderListeTab()}
                {activeTab === "historique" && renderHistoriqueTab()}
            </div>
        </div>
    );
};

export default FacturationGreffe;